const AllLicense = () => {
    return (
        <>
            <h1> AllLicense </h1>
        </>
    );
};

export default AllLicense;
